export default __webpack_public_path__ + "static/Start-2469e6d124f85531683c4652a864214e.png";